import * as I from "immutable";

import {AppData} from "v2/api/Records";

export const apiAppData = (data) => {
  return new AppData({
    ...data,
    destinationType: I.OrderedMap(data.destinationType),
    destinationTypeEditable: I.OrderedMap(data.destinationTypeEditable),
    destinationTypePhysical: I.OrderedMap(data.destinationTypePhysical),
    serviceType: I.OrderedMap(data.serviceType),
    cancelReason: I.OrderedMap(data.cancelReason),
    weekdayType: I.OrderedMap(data.weekdayType),
  });
};

export default {
  apiAppData,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/AppData.js
 **/